import { onError } from 'utils/helpers'
import { requestConfig } from '../../utils/httpClient'

function fetchUsers(data = {}) {
  return async dispatch => {
    dispatch({ type: 'CONTENT_LOADING', isLoading: true })

    function onSuccess(response) {
      const { status_id, detail } = response.data
      if (status_id !== 200) {
        throw response
      }

      dispatch({
        type: 'USERS_INFO',
        users: detail,
      })
      return detail
    }

    try {
      const response = await requestConfig.get(
        `/api/v1/employee?count=${data.count || 50}&page=${data.page || 1}&title=${
          data.title || ''
        }`
      )

      return onSuccess(response)
    } catch (error) {
      throw onError(error)
    } finally {
      dispatch({ type: 'CONTENT_LOADING', isLoading: false })
    }
  }
}

/**
 * Создать нового сотрудника (без фото)
 */
function createUser() {
  return async dispatch => {
    dispatch({ type: 'CONTENT_LOADING', isLoading: true })

    try {
      const response = await requestConfig.post('/api/v1/employee');
      return response.data.detail;
    } catch (error) {
      throw onError(error)
    } finally {
      dispatch({ type: 'CONTENT_LOADING', isLoading: false })
    }
  }
}

/**
 * Добавление фото к карточке сотрудника
 * @param {Object} data
 */
function addUserPhoto(data) {
  return async dispatch => {
    dispatch({ type: 'CONTENT_LOADING', isLoading: true })

    try {
      const response = await requestConfig.post(
        '/api/v1/photo',
        data,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        }
      )

      if (response.data.status_id !== 200) {
        throw response
      }
    } catch (error) {
      throw onError(error)
    } finally {
      dispatch({ type: 'CONTENT_LOADING', isLoading: false })
    }
  }
}

/**
 * Удаление сотрудника
 * @param {Number} userID
 */
function removeUser(userID) {
  return async dispatch => {
    dispatch({ type: 'CONTENT_LOADING', isLoading: true })

    try {
      return await requestConfig.delete(
        `/api/v1/employee?employee_id=${userID}`
      )
    } catch (error) {
      throw onError(error)
    } finally {
      dispatch({ type: 'CONTENT_LOADING', isLoading: false })
    }
  }
}

/**
 * Удаление фото из карточки сотрудника
 * @param {Object} data
 */
function removeUserPhoto(data) {
  return async dispatch => {
    dispatch({ type: 'CONTENT_LOADING', isLoading: true })

    try {
      return await requestConfig.delete(
        `/api/v1/photo?id=[${data}]`
      )
    } catch (error) {
      throw onError(error)
    } finally {
      dispatch({ type: 'CONTENT_LOADING', isLoading: false })
    }
  }
}

export default {
  fetchUsers,
  createUser,
  addUserPhoto,
  removeUser,
  removeUserPhoto,
}
